import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { ENTERPRISE_OPTIMIZATION_FREQUENCY_OPTIONS } from "../../../utils/constants";
import {
  ENTERPRISE_INTAKE_FIELD_OPTIMIZATION_FREQUENCY,
  ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_AGENCY,
  ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_BRAND,
  ENTERPRISE_INTAKE_HINT_OPTIMIZATION_FREQUENCY,
  ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_CAMPAIGNS_COUNT,
} from "../../../i18n/keysTranslations";
import ReadOnlySectionGrid from "../../PreActivation/components/ReadOnlySectionGrid";
import { ENTERPRISE_INTAKE_ORGANIZATION_TYPE_AGENCY } from "../enterpriseIntakeFormValues";
import NumericFieldBlock from "./shared/NumericFieldBlock";
import RadioFieldBlock from "./shared/RadioFieldBlock";
import { mapTranslatedOptions } from "./shared/mapTranslatedOptions";

const CampaignsSection = ({
  control,
  errors,
  readOnly,
  showOptimizationFrequency,
}) => {
  const { t } = useTranslation();
  const organizationType = useWatch({ control, name: "organizationType" });
  const isAgency =
    organizationType === ENTERPRISE_INTAKE_ORGANIZATION_TYPE_AGENCY;
  const campaignsHintKey = isAgency
    ? ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_AGENCY
    : ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_BRAND;

  const optimizationFrequencyOptions = useMemo(
    () =>
      mapTranslatedOptions({
        options: ENTERPRISE_OPTIMIZATION_FREQUENCY_OPTIONS,
        t,
      }),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <NumericFieldBlock
        name="module2MonthlyCampaignsCount"
        labelKey={ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_CAMPAIGNS_COUNT}
        hintKey={campaignsHintKey}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      {showOptimizationFrequency ? (
        <RadioFieldBlock
          name="optimizationFrequency"
          labelKey={ENTERPRISE_INTAKE_FIELD_OPTIMIZATION_FREQUENCY}
          hintKey={ENTERPRISE_INTAKE_HINT_OPTIMIZATION_FREQUENCY}
          required
          options={optimizationFrequencyOptions}
          control={control}
          readOnly={readOnly}
        />
      ) : null}
    </ReadOnlySectionGrid>
  );
};

export default CampaignsSection;
